import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=79fd3b38&scoped=true&lang=pug"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=79fd3b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd3b38",
  null
  
)

export default component.exports